import BaseAPI from "./BaseAPI";
import { trainingAssignmentRoute } from "../routes";

export default class TrainingAssignmentAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, trainingAssignmentRoute, "training-assignment");
    }

    /**
     * Get assignments for the current user
     * @returns {Promise<Array>} Array of assignments for the current user
     */
    async GetMyAssignments() {
        return this._request("get", this._url("/me"));
    }

    /**
     * Get assignments filtered by user ID
     * @param {string} userId - User ID to filter by
     * @returns {Promise<Array>} Array of assignments for the specified user
     */
    async GetByUserId(userId) {
        return this._request("get", this._url(`?user_id=${userId}`));
    }

    /**
     * Mark a training assignment as completed
     * @param {string} id - Assignment ID
     * @returns {Promise<Object>} Updated assignment
     */
    async Complete(id) {
        const result = await this._request("post", this._url(`/${id}/complete`));
        this._emit("complete", id);
        return result;
    }
}
